<template>
  <div>
    <div class="table-section">
      <el-card class="box-card" shadow="never">
        <el-form :inline="true" :model="params" class="demo-form-inline" >
          <el-form-item label="委案日期">
            <el-date-picker v-model="date" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" @change="dateChange" />
          </el-form-item>
          <el-form-item label="案件类型">
            <el-select v-model.trim="params.taskType" placeholder="案件类型">
              <el-option value="" label="全部" />
              <el-option value="1" label="预提醒" />
              <el-option value="0" label="催收" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="exportFun">导出</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { exportAllocateTasks } from '@/api/reportExport'
export default {
  name: 'download',
  data() {
    return {
      headerRowStyle: {
        'background-color': '#6584b4'
      },
      params: {},
      date: []
    }
  },
  computed: {
    ...mapGetters([
      'currentUser'
    ])
  },
  methods: {
    /**
     * 导出
     */
    async exportFun() {
      this.params.userId = this.currentUser.id
      const exportAllocateTasksRes = await exportAllocateTasks(this.params)
      this.$message.success(exportAllocateTasksRes.data)
    },
    dateChange(val) {
      if (val && val.length) {
        this.params.lastBindAgentTimeStart = val[0]
        this.params.lastBindAgentTimeEnd = val[1]
      } else {
        this.params.lastBindAgentTimeStart = ''
        this.params.lastBindAgentTimeEnd = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table-section {
  margin-top: 20px;
}
</style>
